import React from 'react';
import { PrivateRoute } from 'components/PrivateRoute';
import { ShopsListPage } from './ShopsListPage';
import { ShopEditPage } from './ShopEditPage';
import { Switch } from 'react-router';
import { shopsRoutes } from 'routing';
import { useAppStore } from 'store/app-store.hook';

export const ShopsRoutes: React.FC = () => {
  const { permissions } = useAppStore();
  return (
    <Switch>
      {permissions.shopsAccess.view && <PrivateRoute exact path={shopsRoutes.SHOPS} component={ShopsListPage} />}
      {permissions.shopsAccess.view && <PrivateRoute exact path={shopsRoutes.SHOP_NEW} component={ShopEditPage} />}
      {permissions.shopsAccess.view && <PrivateRoute exact path={shopsRoutes.SHOP_EDIT()} component={ShopEditPage} />}
    </Switch>
  );
};
